import { Text } from '@perch-labs/shrike';
import { useState } from 'react';
import { ValidatingInput } from '~/components/validating-input';
import { ConsentLink } from '../perch-consent-components/consent-link.component';
import { TermsWrapper } from '../perch-general.style';

export const PhoneConsent = ({ onChange, consents }) => {
  const [isConsentAccepted, setIsConsentAccepted] = useState(false);

  return (
    <>
      <ValidatingInput
        type="checkbox"
        id="phoneConsent"
        label=""
        name="phoneConsent"
        title="phoneConsent"
        checked={isConsentAccepted}
        value={isConsentAccepted}
        validate={() => isConsentAccepted}
        onChange={value => {
          setIsConsentAccepted(!!value);
          onChange([consents['perch-phone-number-consent'].id], {
            name: 'phoneConsentId',
            isValid: !!value,
          });
        }}
      />
      <TermsWrapper>
        <Text textStyle="paragraph400" color="secondary" textAlign="left" margin="0px 0px 10px 0px">
          {'By checking this box, I am providing Perch permission to '}
          <ConsentLink
            labelText="use my phone number"
            headerText="Phone number consent"
            bodyContent={consents['perch-phone-number-consent'].notes}
          />
          .
        </Text>
      </TermsWrapper>
    </>
  );
};
